module.exports = __webpack_public_path__ + "assets/img/18_1802.81797b37.jpg";